import { render, staticRenderFns } from "./AssetReceiveModal.vue?vue&type=template&id=490d2844&scoped=true&"
import script from "./AssetReceiveModal.vue?vue&type=script&lang=js&"
export * from "./AssetReceiveModal.vue?vue&type=script&lang=js&"
import style0 from "./AssetReceiveModal.vue?vue&type=style&index=0&id=490d2844&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490d2844",
  null
  
)

export default component.exports